// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Et0z","type":"styles_type__3xJel","choices":"styles_choices__f_xnT"};